import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const qualitySummarySlice = createSlice({
  name: "qualitySummary",
  initialState: {
    apiLoading: {
      kpi: false,
      trendArea: false,
    },
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    strategicRiskKPIData: {
      "QUALITY RISK SCORE": {
          "MoM": 100,
          "QoQ": 100,
          "value": 0.42
      },
      "COMPLAINTS PER MILLION LBS(CPM)": {
          "MoM": -286.2,
          "QoQ": -285.26,
          "value": 0.189
      }
    },
    trendAreaData: [],
    resetTriggered: false,
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
    setQualityRiskKPIData(state, action) {
      state.qualityRiskKPIData = action.payload;
    },
    setTrendAreaData(state, action) {
      state.trendAreaData = action.payload;
    },
  },
});

export const {
  setLoader,
  setResetTriggered,
  setFilters,
  setQualityRiskKPIData,
  setTrendAreaData,
} = qualitySummarySlice.actions;

export default qualitySummarySlice.reducer;
